<template>
  <blockquote class="ctype__quote">
    <font-awesome-icon icon="quote-left"
                       :style="{ color: '#886B25' }"
                       size="3x"
    />
    <div class="text">
      <div class="quote h2">{{ content.blockquote }}</div>
      <cite class="cite">{{ content.cite }}</cite>
    </div>
  </blockquote>
</template>

<script>
  export default {
    name: 'Quotation',
    props: {
      content:{
        type: Object,
        required: true
      }
    }
  }
</script>

<style src="./Quotation.scss" lang="scss"></style>
